import React, { useRef } from 'react';
import styled from 'styled-components';
import Chip from '../Chip/Chip';
import FilterPopup from './FilterPopup';

const FilterWrap = styled.div`
  position: relative;
  .filter-content-wrap {
  }
`;

const FilterItem = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing02};
  display: flex;
`;

export default function Filter({
  shouldDisplaySaveChangesButton,
  popupPosition,
  popupDirection,
  size,
  label,
  children,
  isOpen,
  onToggleClick,
  onCloseClick,
  onSaveChangesClick,
  chipClassName,
  onOutsideClick,
}) {
  const filterRef = useRef();
  return (
    <FilterWrap ref={(el) => (filterRef.current = el)}>
      <Chip
        className={chipClassName}
        isActive={isOpen}
        onClick={(event) => {
          event.stopPropagation();
          onToggleClick(isOpen);
        }}
      >
        {label}
      </Chip>
      {isOpen ? (
        <FilterPopup
          onOutsideClick={onOutsideClick}
          shouldDisplaySaveChangesButton={shouldDisplaySaveChangesButton}
          popupPosition={popupPosition}
          popupDirection={popupDirection}
          size={size}
          onSaveChangesClick={onSaveChangesClick}
          onClosePopupClick={onCloseClick}
          ref={filterRef}
        >
          {children.map((child, index) => (
            <FilterItem key={index}>{child}</FilterItem>
          ))}
        </FilterPopup>
      ) : null}
    </FilterWrap>
  );
}
